import { EditOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
    Button,
    Checkbox,
    Form,
    Input,
    Modal,
    Radio,
    Select,
    Tooltip,
    Switch
} from 'antd';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { loadAllSalaryComponents, updateSalaryComponents } from '../../redux/rtk/features/salaryComponent/salaryComponentSlice';

const EditSalaryComponent = ({ record }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEnabled, setIsEnabled] = useState(record.status || false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { Option } = Select;

  const showModal = () => {
    form.setFieldsValue({
      componentType: record.componentType,
      componentName: record.componentName,
      calculationType: record.calculationType,
      proRata: record.proRata,
      taxable: record.taxable
    });
    setIsEnabled(record.status || false);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const onFinish = async (values) => {
    const resp = await dispatch(updateSalaryComponents({ 
      id: record.id, 
      // values: values 
      values: { ...values, status: isEnabled }
    }));
    
    if (resp.payload.message === 'success') {
      setIsModalVisible(false);
      dispatch(loadAllSalaryComponents());
    }
  };

  const handleToggle = (checked) => {
    setIsEnabled(checked);
  };

  return (
    <>
      <Button 
        type="primary" 
        icon={<EditOutlined />}
        onClick={showModal}
        className="mr-2"
      />
      <Modal
        title="Edit Salary Component"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          initialValues={{
            componentType: record.componentType,
            componentName: record.componentName,
            calculationType: record.calculationType,
            proRata: record.proRata,
            taxable: record.taxable
          }}
        >
          <Form.Item
            label="Component Type"
            name="componentType"
            rules={[{ required: true, message: 'Please select component type!' }]}
          >
            <Radio.Group>
              <Radio value="Income">Income</Radio>
              <Radio value="Deduction">Deduction</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="Component Name"
            name="componentName"
            rules={[{ required: true, message: 'Please input component name!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Calculation Type"
            name="calculationType"
            rules={[{ required: true, message: 'Please select calculation type!' }]}
          >
            <Select>
              <Option value="Amount">Amount</Option>
              <Option value="% of Basic">Percentage of Basic</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label={
              <span>
                Pro-rata basis
                <Tooltip title="Pro-rata basis means the calculation is based on a proportionate basis">
                  <InfoCircleOutlined className="ml-2" />
                </Tooltip>
              </span>
            }
            name="proRata"
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>

          <Form.Item
            label="Taxable Component"
            name="taxable"
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>

          {/* <Form.Item
            label="Enable/Disable"
            valuePropName="checked"
          >
            <Switch 
              checked={isEnabled} 
              onChange={handleToggle} 
            />
          </Form.Item> */}

          <Form.Item className="text-right">
            <Button type="default" onClick={handleCancel} className="mr-2">
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditSalaryComponent;